import { EMAIL_VERIFICATION_COPY } from '../../consts';
import { profileEmailSectionStyles } from './profile-email-section.styles';

type ProfileEmailChangeFormProps = {
  emailDraft: string;
  passwordDraft: string;
  emailError: string;
  passwordError: string;
  isSubmitting: boolean;
  onEmailDraftChange: (value: string) => void;
  onPasswordDraftChange: (value: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
};

export const ProfileEmailChangeForm = ({
  emailDraft,
  passwordDraft,
  emailError,
  passwordError,
  isSubmitting,
  onEmailDraftChange,
  onPasswordDraftChange,
  onCancel,
  onSubmit,
}: ProfileEmailChangeFormProps) => (
  <form
    className={profileEmailSectionStyles.formPanel}
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
    noValidate
  >
    <label htmlFor="new-email" className={profileEmailSectionStyles.fieldLabel}>
      {EMAIL_VERIFICATION_COPY.newEmailLabel}
    </label>
    <input
      id="new-email"
      name="new-email"
      type="email"
      autoComplete="email"
      spellCheck={false}
      value={emailDraft}
      onChange={(event) => onEmailDraftChange(event.target.value)}
      placeholder={EMAIL_VERIFICATION_COPY.newEmailPlaceholder}
      aria-invalid={Boolean(emailError)}
      aria-describedby={emailError ? 'new-email-error' : undefined}
      className={profileEmailSectionStyles.fieldInput}
    />
    {emailError ? (
      <p id="new-email-error" className={profileEmailSectionStyles.error} role="alert">
        {emailError}
      </p>
    ) : null}
    <label htmlFor="current-password" className={profileEmailSectionStyles.fieldLabel}>
      {EMAIL_VERIFICATION_COPY.currentPasswordLabel}
    </label>
    <input
      id="current-password"
      name="current-password"
      type="password"
      autoComplete="current-password"
      value={passwordDraft}
      onChange={(event) => onPasswordDraftChange(event.target.value)}
      placeholder={EMAIL_VERIFICATION_COPY.currentPasswordPlaceholder}
      aria-invalid={Boolean(passwordError)}
      aria-describedby={passwordError ? 'change-email-form-error' : undefined}
      className={profileEmailSectionStyles.fieldInput}
    />
    {passwordError ? (
      <p id="change-email-form-error" className={profileEmailSectionStyles.error} role="alert">
        {passwordError}
      </p>
    ) : null}
    <div className="flex flex-wrap justify-end gap-2.5">
      <button type="button" onClick={onCancel} className={profileEmailSectionStyles.secondary}>
        {EMAIL_VERIFICATION_COPY.cancelChange}
      </button>
      <button type="submit" disabled={isSubmitting} className={profileEmailSectionStyles.primary}>
        {EMAIL_VERIFICATION_COPY.continueChange}
      </button>
    </div>
  </form>
);
